// generated from 203_495 samples

import { z } from "zod";
import { common } from "../common";
import { clickActionSchema } from "../shared/clickActionSchema";
import { messageGetBaseSchema } from "./messageGetBaseSchema";
import { orBehaviorTriggerGetSchema } from "../trigger/orBehaviorTriggerGetSchema";
import { triggerGetSchema } from "../trigger/triggerGetSchema";

export const contentCardMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("contentCard"),
  analytics_id: common.objectId,
  // null: 201_795 (99.16%)
  android_bap: z.array(z.string()).nullable().optional(),
  // null: 203_494 (100.00%)
  android_china_bap: z.array(z.string()).nullable().optional(),
  // null: 63_726 (31.32%)
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  android_china_click_action: clickActionSchema.nullable().optional(),
  // null: 203_470 (99.99%)
  android_china_uri: z.string().nullable().optional(),
  // null: 33_873 (16.65%)
  android_china_use_webview: z.boolean().nullable().optional(),
  // null: 34_105 (16.76%)
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  android_click_action: clickActionSchema.nullable().optional(),
  // null: 110_770 (54.43%)
  android_uri: z.string().nullable().optional(),
  // null: 33_873 (16.65%)
  // true 12_984 (7.65%), false 156_638 (92.35%)
  android_use_webview: z.boolean().nullable().optional(),
  // null: 151_067 (74.24%)
  // avg: 1735858736.01, min: 1535671567, max: 1749561303
  cards_removed_at: z.int().nonnegative().nullable().optional(),
  // null: 33_875 (16.65%)
  content_id: common.objectId.nullable().optional(),
  // null: 34_119 (16.77%)
  description: z.string().nullable().optional(),
  // null: 33_873 (16.65%)
  // true 72_162 (42.54%), false 97_460 (57.46%)
  enqueues_sender_job: z.boolean().nullable().optional(),
  // null: 148_475 (72.96%)
  // avg: 1744510710.23, min: 1528858500, max: 33122408400
  expiration_value_time: z.int().nonnegative().nullable().optional(),
  // null: 55_252 (27.15%)
  // avg: 873227.69, min: -345600, max: 31536000
  expiration_value_ttl: z.int().nullable().optional(),
  // true 17_476 (8.59%), false 186_019 (91.41%)
  expire_in_local_time: z.boolean().nullable().optional(),
  // null: 34_162 (16.79%)
  extras: z.record(z.string(), z.string()).nullable().optional(),
  image_alt: z.string().nullable().optional(),
  // null: 42_760 (21.01%)
  // integer: 111_570 (69.41%)
  // avg: 1.42, min: 0.16731266149870802, max: 800
  image_aspect_ratio: z.number().nonnegative().nullable().optional(),
  // null: 88_081 (43.28%)
  image_url: z.string().nullable().optional(),
  // null: 201_729 (99.13%)
  ios_bap: z.array(z.string()).nullable().optional(),
  // null: 34_162 (16.79%)
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  ios_click_action: clickActionSchema.nullable().optional(),
  // null: 107_757 (52.95%)
  ios_uri: z.string().nullable().optional(),
  // null: 33_873 (16.65%)
  // true 14_320 (8.44%), false 155_302 (91.56%)
  ios_use_webview: z.boolean().nullable().optional(),
  // null: 33_873 (16.65%)
  // true 10_780 (6.36%), false 158_842 (93.64%)
  is_custom_image_url: z.boolean().nullable().optional(),
  kepler_bap: z.array(z.string()).nullable().optional(),
  // null: 149_753 (73.59%)
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  kepler_click_action: clickActionSchema.nullable().optional(),
  kepler_uri: z.string().nullable().optional(),
  // null: 33_873 (16.65%)
  kepler_use_webview: z.boolean().nullable().optional(),
  // null: 203_481 (99.99%)
  kindle_bap: z.array(z.string()).nullable().optional(),
  // null: 35_819 (17.60%)
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  kindle_click_action: clickActionSchema.nullable().optional(),
  // null: 203_145 (99.83%)
  kindle_uri: z.string().nullable().optional(),
  // null: 33_873 (16.65%)
  // true 155 (0.09%), false 169_467 (99.91%)
  kindle_use_webview: z.boolean().nullable().optional(),
  // null: 75_959 (37.33%)
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  landing_page_click_action: clickActionSchema.nullable().optional(),
  // null: 203_487 (100.00%)
  landing_page_uri: z.string().nullable().optional(),
  language: z.string().nullable().optional(),
  // avg: 202802939.03, min: 0, max: 1749556802
  last_sent_content_cards: z.int().min(0).optional(),
  // null: 10 (0.00%)
  link_template_ids: z.array(z.string()).nullable().optional(),
  personalized_expiration_duration_variable: z.string().nullable().optional(),
  personalized_expiration_duration_variable_type: z.string().nullable().optional(),
  personalized_expiration_duration_variable_unit: z.string().nullable().optional(),
  // null: 33_873 (16.65%)
  // true 16_209 (9.56%), false 153_413 (90.44%)
  pinned: z.boolean().nullable().optional(),
  // null: 33_873 (16.65%)
  // true 68_798 (40.56%), false 100_824 (59.44%)
  push_embeddable: z.boolean().nullable().optional(),
  // undefined: 165_720 (81.44%), defined 37_775 (18.56%)
  removal_schedule: z
    .object({
      removal_event: z.union([orBehaviorTriggerGetSchema, triggerGetSchema]),
    })
    .nullable()
    .optional(),
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  roku_click_action: clickActionSchema.nullable().optional(),
  roku_uri: z.string().nullable().optional(),
  // null: 34_119 (16.77%)
  title: z.string().nullable().optional(),
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  tvos_click_action: clickActionSchema.nullable().optional(),
  tvos_uri: z.string().nullable().optional(),
  // null: 232 (0.11%)
  type: z.enum(["CLASSIC", "CAPTIONED_IMAGE", "CONTROL", "BANNER"]).nullable().optional(),
  // null: 147_269 (72.37%)
  uri_text: z.string().nullable().optional(),
  // null: 202_472 (99.50%)
  web_bap: z.array(z.string()).nullable().optional(),
  // null: 34_162 (16.79%)
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  web_click_action: clickActionSchema.nullable().optional(),
  // null: 152_146 (74.77%)
  web_uri: z.string().nullable().optional(),
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  windows8_click_action: clickActionSchema.nullable().optional(),
  windows8_uri: z.string().nullable().optional(),
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  windows_click_action: clickActionSchema.nullable().optional(),
  windows_uri: z.string().nullable().optional(),
});
